import React from 'react';
import './manutencao.css'; // Arquivo CSS separado

const MaintenancePage = () => {
  return (
    <div className="maintenance-container">
      <div className="maintenance-box">
        <h1 className="maintenance-title">Em Manutenção</h1>
        <p className="maintenance-message">
          Estamos realizando algumas atualizações importantes para melhorar nossos serviços.
        </p>
        <p className="maintenance-message">
          Voltaremos em breve. Agradecemos sua paciência!
        </p>
        <div className="loader"></div>
      </div>
    </div>
  );
};

export default MaintenancePage;
